<ion-header>
  <ion-toolbar style="background-color: red;">
    <ion-title>Sentiment Analysis</ion-title>
    <ion-buttons slot="end">
      <ion-title style="cursor: pointer;" size="large" (click)="goToMenu()">Menu</ion-title>
      <ion-title style="cursor: pointer;" size="large" (click)="confirmLogout()">Logout</ion-title>

      <!-- icon to show the user profile -->
      <!-- <ion-icon name="person-circle-outline" class="profile-icon" (click)="openProfile()" style="margin-right: 10px;" title="profile"></ion-icon> -->
     

    </ion-buttons>
  </ion-toolbar>
  <ion-row style="background-color: #f1f1f1;">
    
    <ion-col size="2" style="display: revert;padding:0px 10px">
    <ion-item style="background-color: #f1f1f1;">
      <ion-label position="floating">Language</ion-label>
      <ion-select [(ngModel)]="selectedOption" (ionChange)="onOptionChange($event)">
        <ion-select-option *ngFor="let option of options" [value]="option.value">
          {{ option.label }}
        </ion-select-option>
      </ion-select>
    </ion-item>
    </ion-col>

    <!-- <ion-col size="2" style="display: revert;padding:0px 10px">
    <ion-item>
      <ion-label position="floating">Category</ion-label>
            <ion-select [(ngModel)]="selectedOptionCategory" (ionChange)="onOptionCategoryChange($event)">
              <ion-select-option *ngFor="let option of options_category" [value]="option.value">
                {{ option.label }}
              </ion-select-option>
      </ion-select>
    </ion-item>
    </ion-col> -->

    <!-- <ion-col size="2" style="display: revert;padding:0px 10px">
      <ion-item>
        <ion-label position="floating">Own Recorded</ion-label>
              <ion-select [(ngModel)] = "selectedOptionRecordedText" (ionChange)="onOptionRecordedTextChange($event)">
                <ion-select-option *ngFor="let option of options_recorded_text" [value]="option.value">
                  {{ option.label }}
                </ion-select-option>
        </ion-select>
      </ion-item>
    </ion-col> -->
    <!-- <ion-col size="2" style="display: revert;padding:0px 10px">
      <ion-item>
        <ion-label position="floating">Total Recorded</ion-label>
              <ion-select [(ngModel)] = "selectedOptionTotalRecordedText" (ionChange)="onOptionTotalRecordedTextChange($event)">
                <ion-select-option *ngFor="let option of filteredTotalRecordedOptions" [value]="option.value">
                  {{ option.label }}
                </ion-select-option>
        </ion-select>
      </ion-item>
    </ion-col> -->

    

    <ion-col size="9" style="display: revert;padding:0px 10px"></ion-col>
    <ion-col size="1" style="display: revert; padding: 0px 10px;">
      <!-- <div class="tooltip-wrapper">
        <ion-button class="zoom-icon-button" fill="clear" color="primary">
          <ion-icon slot="icon-only" name="add-circle-outline"></ion-icon>
        </ion-button>
        <span class="custom-tooltip-below">Add Data</span>
      </div> -->
      <div class="tooltip-wrapper">
        <ion-button class="zoom-icon-button" fill="clear" color="primary" (click)="openPopupForModelInferencing()">
        <!-- <ion-button class="zoom-icon-button" fill="clear" color="primary"> -->
          <ion-icon slot="icon-only" name="eye-outline"></ion-icon>
        </ion-button>
        <span class="custom-tooltip-below">Model Inference</span>
      </div>
      
      
    </ion-col>

  
    
    
   

  </ion-row>
</ion-header>


<ion-content class="no-hover-page" [fullscreen]="true">
  <ng-container >
    <ion-card *ngIf="textListData.length > 0; else nodata"  style="padding-bottom: 90px;">
      <!-- <ion-grid style="margin-bottom: 80px;"> -->
        <!-- Table Headers -->
        <ion-row class="table-header">
          <ion-col size="1"><strong>Index</strong></ion-col>
          <ion-col size="3"><strong>Text</strong></ion-col>
          <ion-col size="2"><strong>Predicted Sentiment</strong></ion-col>
          <ion-col size="2"><strong>Sentiment Score</strong></ion-col>
          <ion-col size="2"><strong>Corrected Sentiment</strong></ion-col>
          <ion-col size="1"><strong>Flag</strong></ion-col>
          <ion-col size="1" style="padding-left: 25px;"><strong>Actions</strong></ion-col>

        </ion-row>
    
        <!-- Table Rows -->
         
        <ion-row *ngFor="let item of textListData; let i = index" class="table-row">
          <ion-col size="1">{{ i + 1 }}</ion-col>
          <ion-col size="3">{{ item.input_text }}</ion-col>
          <ion-col size="2">{{ item.predicted_sentiment }}</ion-col>
          <ion-col size="2">{{ (item.confidence_score * 100) | number:'1.2-2' }}%</ion-col>
          <ion-col size="2">{{ item.flag_reason }}</ion-col>
          <ion-col size="1">{{ item.flag_status }}</ion-col>
          <ion-col size="1">
        
            <div class="tooltip-wrapper">
              <!-- <ion-button class="zoom-icon-button" fill="clear" color="primary" (click)="updateText(item)"> -->
              <ion-button class="zoom-icon-button" fill="clear" color="primary" disabled>
                <ion-icon slot="icon-only" name="create-outline"></ion-icon>
              </ion-button>
              <span class="custom-tooltip">Edit Data</span>
            </div>
            <!-- <div class="tooltip-wrapper">
              <ion-button class="zoom-icon-button" fill="clear" color="primary" (click)="deleteText(item)">
                <ion-icon slot="icon-only" name="trash-outline" ></ion-icon>
              </ion-button>
              <span class="custom-tooltip">Delete Text</span>
            </div> -->
          </ion-col>
        </ion-row>
        
      <!-- </ion-grid> -->
    </ion-card>

    <!-- No Data Available Message -->
    <ng-template #nodata>
      <ion-card>
        <ion-row>
          <ion-col>No data available.</ion-col>
        </ion-row>
      </ion-card>
    </ng-template>

  </ng-container>  
</ion-content>

<ion-footer class="pagination-footer">
  <ion-toolbar>
    <ion-row class="pagination-row">
      <!-- First & Previous Page Buttons -->
      <ion-col size="auto">
        <ion-button [disabled]="currentPage === 1" (click)="goToFirstPage()">
          <ion-icon name="play-back-outline"></ion-icon>
        </ion-button>
        <ion-button [disabled]="currentPage === 1" (click)="prevPage()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <!-- Page Number Display -->
      <ion-col size="auto" class="text-center">
        <ion-item lines="none">
          <span>{{ currentPage }} / {{ totalPages }}</span>
        </ion-item>
      </ion-col>

      <!-- Next & Last Page Buttons -->
      <ion-col size="auto">
        <ion-button [disabled]="currentPage === totalPages" (click)="nextPage()">
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </ion-button>
        <ion-button [disabled]="currentPage === totalPages" (click)="goToLastPage()">
          <ion-icon name="play-forward-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <!-- Go to Specific Page Input -->
      <ion-col size="auto">
        <ion-item lines="none">
          <ion-input type="number" [(ngModel)]="currentPage" placeholder="Page #" min="1" [max]="totalPages"></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="auto">
        <ion-button [disabled]="!currentPage || currentPage < 1 || currentPage > totalPages" 
                    (click)="goToSpecificPage(currentPage)">
          GO
        </ion-button>
      </ion-col>

      <!-- Page Size Selector -->
      <ion-col size="auto">
        <ion-item>
          <!-- <ion-label>Page Size</ion-label> -->
          <ion-select [(ngModel)]="pageSize" (ionChange)="onPageSizeChange()">
            <ion-select-option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>


    </ion-row>
  </ion-toolbar>
</ion-footer>
